// extracted by mini-css-extract-plugin
module.exports = {"NotesTable":"NotesTable_NotesTable__2r9YI"};